import { Component, computed, OnDestroy, OnInit, signal } from '@angular/core';
import { IncidentService } from '../../shared/incident.service';
import { NotificationService } from '../../shared/notification.service';
import { Router } from '@angular/router';
import { Incident } from '../../models/incident';
import { AppModule } from '../../app.module';
import { ReportService } from '../../shared/report.service';
import { AuthService } from '../../auth.service';
import { IncidentSearch } from "../incident-search/incident-search";
import { OpenIncidentTable } from "../open-incident-table/open-incident-table";
import { IncidentStatusCategory } from '../../shared/enums';
import { Base64Report } from '../../models/report';
import { Subscription } from 'rxjs';
import { ClosedIncidentTable } from "../closed-incident-table/closed-incident-table";

@Component({
  selector: 'app-incident-list',
  imports: [AppModule, OpenIncidentTable, ClosedIncidentTable],
  templateUrl: './incident-list.html',
  styleUrl: './incident-list.less'
})
export class IncidentListComponent implements OnInit, OnDestroy{

  public IncidentStatusCategory = IncidentStatusCategory;

  public selectedTabIndex = signal(0);
  public openIncidents = computed(() => this.incidentService.openIncidents());
  
  // public closedIncidents = signal<Incident[]>([]);
  // public pastIncidents = signal<Incident[]>([]);
  public isClosed = computed<boolean>(() => this.selectedTabIndex() === 1);

  public openIncidentsLoading = computed(() => this.incidentService.isLoadingOpenIncidents());

  public closedIncidentsLoading = signal<boolean>(false);
  public pastIncidentsLoading = signal<boolean>(false);

  public isLoading = signal<boolean>(false);
  public etaChanges = signal<Map<number, number>>(new Map());

  private etaUpdateSubscription: Subscription;

  constructor(public incidentService: IncidentService, 
    public notification: NotificationService,
    public router: Router,
    public reportService: ReportService,
    public authService: AuthService) { }


  ngOnInit(): void {

    // this.incidentService.loadTodayIncidents().subscribe({
    //   error: (error) => {
    //     this.notification.showError('Failed to load incidents', error.message);
    //   }
    // });
    
    //this.loadIncidents(); one would expect womthing like this here, amirite? Dude, @Nic, srsly, the architecture is a bit rough. Now one needs to go look where we actually load the incidents
    this.etaUpdateSubscription = this.incidentService.$etaUpdate.subscribe((etaUpdate) => {
      //find the incident in the openIncidents list and update its ETA
      const incident = this.openIncidents().find(i => i.incidentId === etaUpdate.incidentId);
      if (incident) {
        // Calculate the difference in minutes
        const oldEta = new Date(incident.breakdownTechnicianDriverEta);
        const newEta = new Date(etaUpdate.newEta);
        const diffInMinutes = Math.round((newEta.getTime() - oldEta.getTime()) / (1000 * 60));
        
        // Update the incident's ETA
        incident.breakdownTechnicianDriverEta = etaUpdate.newEta;
        
        // Trigger CD
        //this.openIncidents.set([...this.openIncidents()]);
        
        // Store the ETA change for visual indicator
        const currentChanges = new Map(this.etaChanges());
        currentChanges.set(etaUpdate.incidentId, diffInMinutes);
        this.etaChanges.set(currentChanges);
        
        // Remove the indicator after 10 seconds
        setTimeout(() => {
          const updatedChanges = new Map(this.etaChanges());
          updatedChanges.delete(etaUpdate.incidentId);
          this.etaChanges.set(updatedChanges);
        }, 10000);
      }
      //We do not need to check closed or past incidents as ETAs are only relevant for open incidents.
    });
  }

  ngOnDestroy(): void {
    //cleanup if needed
    this.etaUpdateSubscription?.unsubscribe();
  }
  public exportIncidents(): void {
    this.reportService.exportIncidentsToExcel().subscribe({
      next: (report: Base64Report) => {
        this.notification.showSuccess('Breakdowns exported successfully. Download will start shortly.');
        this.downloadFile(report);
      },
      error: (error) => {
        this.notification.showError('Failed to export breakdowns: ' + error.message);
      }
    });
  }

  private downloadFile(report: Base64Report) {
    const link = document.createElement('a');
    link.href = 'data:' + report.fileType + ';base64,' + report.base64Data;
    link.download = report.fileName;
    link.click();
  }
}